import Vue from 'vue';
import VueRouter from 'vue-router';
import HomePage from '@/views/HomePage.vue';
import MainContent from '@/components/MainContentPage.vue';
import Services from '@/components/ServicesPage.vue';
import Resources from '@/components/ResourcesPage.vue';
import Team from '@/components/TeamPage.vue';
import Testimonials from '@/components/TestimonialsPage.vue';
import Contact from '@/components/ContactPage.vue';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'HomePage',
        component: HomePage
    },
    {
        path: '/main_content',
        name: 'MainContentPage',
        component: MainContent
    },
    {
        path: '/services',
        name: 'ServicesPage',
        component: Services
    },
    {
        path: '/resources',
        name: 'ResourcesPage',
        component: Resources
    },
    {
        path: '/team',
        name: 'TeamPage',
        component: Team
    },
    {
        path: '/testimonials',
        name: 'TestimonialsPage',
        component: Testimonials
    },
    {
        path: '/contact',
        name: 'ContactPage',
        component: Contact
    }
];

const router = new VueRouter({
    routes,
    // 添加以下代码来配置页面切换动画
    scrollBehavior() {
        return { x: 0, y: 0 }; // 页面切换时滚动条回到顶部，可根据需求调整
    },
    mode: 'history',
    base: process.env.BASE_URL,
    linkActiveClass: 'active-link', // 用于给当前激活的路由链接添加样式类，可自定义类名
    linkExactActiveClass: 'exact-active-link' // 用于给精确匹配当前路由的链接添加样式类，可自定义类名
});

// 全局前置守卫，用于添加页面切换动画逻辑
router.beforeEach((to, from, next) => {
    document.body.classList.add('page-transition'); // 添加动画类名，触发动画开始
    next();
});

// 全局后置守卫，用于在动画结束后移除动画类名
router.afterEach(() => {
    document.body.classList.remove('page-transition'); // 移除动画类名，动画结束
});

export default router;